import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import * as actions from "../../../store/usersLabs/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const payload = { page: 1, sort: "blocked_at,asc", roleId: 7 };
  const [citiesList, setCitiesList] = useState([]);
  const { cities } = useSelector((state) => state?.usersLabs);

  useEffect(() => {
      dispatch(actions.getCitiesRequest());
  }, [dispatch]);

  useEffect(() => {
    if (cities && cities.length > 0) {
      let list = [{
        id: 0,
        name: messages.usersLabs.allcities,
      }];
      cities.forEach((item) => {
        list.push({
          id: item.id,
          name: item.name,
        });
      });
      setCitiesList(list);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cities]);  

  const initialValues = {
    search: "",
    cityId: 0, //ddl
  };

  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    cityId: Yup.object().nullable(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });
  
  
  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value)
    dispatch(
      actions?.getUsersLabsRequest({
        ...payload,
        search: e.target.value,
        cityId: formik.values.cityId,
      })
    );
    setSearchValues({search: formik.values.search, cityId: formik.values.cityId});
  };

  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    dispatch(
      actions?.getUsersLabsRequest({
        ...payload,
        search: formik.values.search,
        cityId: e.target.value,
      })
    );
    setSearchValues({search: formik.values.search, cityId: formik.values.cityId});
  };

  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.usersLabs.search}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            <SelectComponent
              className={'bg-white'}
              size="small"
              name="cityId"
              list={citiesList}
              keyName="name"
              valueKeyName="id"
              value={formik.values.cityId}
              handleChange={(e) => searchWithSelect(e, "cityId")}
              error={formik.errors.requestSource}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
